import { pickApi } from "./pick";

export const {
  useLazyGetPickQuery,
  useGetPicksQuery,
  useCaptureWeightMutation,
  useRejectWeightMutation,
  useGetCapturedWeightStateMutation,
  useVerifyPickMutation,
  useCompletePickMutation,
  useSplitPickMutation
} = pickApi;
